import { forwardRef } from "react";
import classNames from "classnames";
import { Radio } from "antd";
import type { GetRef, RadioProps } from "antd/lib";
import styles from "./styles.module.scss";

type RadioButtonRefType = GetRef<typeof Radio>;

export const AppRadio = forwardRef<RadioButtonRefType, RadioProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Radio ref={ref} className={classNames(styles.radio, className)} {...props}>
        {children}
      </Radio>
    );
  },
);
